import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/indexReducer';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

const logger = createLogger();
// create redux store and connect to logger
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
